module.exports = __webpack_public_path__ + "static/media/j2wlogo_v1.e2af2367.png";